import { Injectable } from '@angular/core';
import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable, HttpsCallableResult } from '@angular/fire/functions';
import { from, Observable } from 'rxjs';
import { SignupVenueData } from '@blazebite/shared-models';

@Injectable({
  providedIn: 'root'
})
export class AdminFunctionsService {
  //private functions: Functions = inject(Functions);

  constructor() { }

  private createFunctions() {
    const functions = getFunctions(getApp());
    // Need this to point to local emulator
    // connectFunctionsEmulator(functions, 'localhost', 5001);
    return functions;
  }

  /**
   * Passwordless signup submission: records the prospect server-side, which
   * creates the venue and emails the user a portal invite to set up their
   * credentials. Requires the (anonymous) Firebase auth session.
   */
  submitSignupProspect(email: string, venueData: SignupVenueData): Observable<HttpsCallableResult> {
    const functions = this.createFunctions();
    const submitSignupProspect = httpsCallable(functions, 'signup-submitSignupProspect')
    return from(submitSignupProspect({ emailAddress: email, venueData: venueData }));
  }

  createNewPaymentAccountIntegration(country: string, url: string) : Observable<HttpsCallableResult> {
    const functions = this.createFunctions();
    const createNewPaymentAccountIntegration = httpsCallable(functions, 'accountCreate-createPaymentAccountIntegration')
    return from(createNewPaymentAccountIntegration({ country, url }));
    
  }
}